export default __webpack_public_path__ + "static/media/6 - Icon along the Path.9f92396e.jpeg";